import React, { useEffect, useState, Fragment } from 'react';
import PropTypes from 'prop-types';

import mixpanel from 'mixpanel-browser';

// Firebase
import { db } from '../../config/firebase-config';
import { collection, getDocs, getDoc, addDoc, updateDoc, doc, setDoc, deleteDoc, query, where, onSnapshot, orderBy, startAfter, limit } from 'firebase/firestore';

// Redux
import { connect } from 'react-redux';

// Date formatting
// import { format, lightFormat } from 'date-fns';

// Actions
import { pauseAd, stopAd, activateAd } from '../../actions/adActions';

// Components
import Modal from '../modal/Modal';
import ModalContainer from '../modal/ModalContainer';

// Icons
import { Button } from '@material-ui/core';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';

const Ad_Block = ({
        ad_details,
        pauseAd, 
        stopAd,
        activateAd
}) => {

    // -- Modal toggle values --

    // Stop Ad
    const [stopModal, setStopModal] = useState(false);
    // Pause Ad
    const [pauseModal, setPauseModal] = useState(false);
    // Resume Ad
    const [resumeModal, setResumeModal] = useState(false);

    // -- END: Modal toggle values --

    // -- Ad Info --
    const [adDoc, setAdDoc] = useState(null);
    const [adLoading, setAdLoading] = useState(true);
    const [adBudget, setAdBudget] = useState(null);
    const [adSpend, setAdSpend] = useState(null);

    const [timeLeft, setTimeLeft] = useState(null);

    // -- END: Ad Info --

    // Post Info
    const [postDoc, setPostDoc] = useState(null);

    // Retrieve the current URL path and split it into an array
    let previousURL = window.location.pathname;
    var pathArray = previousURL.split( '/' );

    useEffect(() => {
        if (!ad_details) return;

        const docRef = doc(db, 'ads', ad_details._id);

        // Subscribe to real-time updates
        const unsubscribe = onSnapshot(docRef, (snapshot) => {
            if (snapshot.exists()) {
                setAdDoc({ _id: snapshot.id, ...snapshot.data() });

                const amount_budgeted = (snapshot.data().budget.amount_budgeted / 100).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD'
                });

                const total_spent = (snapshot.data().budget.total_spent / 100).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD'
                });

                setAdBudget(amount_budgeted);
                setAdSpend(total_spent);
            } else {
                setAdDoc(null);
                setAdBudget(null);
                setAdSpend(null);
            }
            setAdLoading(false);
        }, (error) => {
            setAdDoc(null);
            setAdBudget(null);
            setAdSpend(null);
            console.log("Error listening to Ad document:", error);
            setAdLoading(false);
        }
        );

        // Clean up listener when unmounting
        return () => unsubscribe();
    }, [ad_details]);

    useEffect(() => {
        if(adDoc) {
            let time_left;

            if (adDoc.status === "paused" && adDoc.paused_at) {
                // If paused, freeze the countdown
                time_left = adDoc.end_time_adjusted - (adDoc.paused_at + adDoc.time_paused);
            } else {
                // If active, update countdown
                time_left = adDoc.end_time_adjusted - Date.now();
            }
            setTimeLeft(time_left);
        }

    }, [adDoc]);

    useEffect(() => {
        if (!adDoc) return;

        updatePostInfo();
    }, [adDoc]);

    const updatePostInfo = async () => {
        if (!adDoc) return;

        const postRef = doc(db, 'posts', adDoc.postId);
        
        try {
            const postSnapshot = await getDoc(postRef);

            if (!postSnapshot.exists()) {
                throw new Error(`Post with id ${adDoc.postId} not found`);
            }

            setPostDoc({ ...postSnapshot.data(), _id: postSnapshot.id });
        } catch (err) {
            console.error("Couldn't get post info from Ad:", err);
            throw err; // rethrow so caller can handle it
        }
    }

    // Help function (format ms into date format)
    const formatTimeLeft = (ms) => {
        if (ms <= 0) return "Expired";

        const totalSeconds = Math.floor(ms / 1000);
        const days = Math.floor(totalSeconds / (3600 * 24));
        const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);

        if (days > 0) return `${days}d ${hours}h ${minutes}m`;
        if (hours > 0) return `${hours}h ${minutes}m`;
        return `${minutes}m`;
    }

    return (
        <Fragment>
            <div className={`order hoverEffects ${pathArray[2] && ad_details._id === pathArray[2] ? 'active' : ''}`} key={ad_details._id} style={{cursor: 'pointer', position: 'relative'}}>

                <div className='order__headerText' style={{display: 'flex', justifyContent: 'space-between'}}>
                    <h3 className='line-clamp' style={{marginBottom: '10px', overflow:'hidden' , fontSize:'16px', fontWeight:'600', color:'#000', maxWidth:'100%'}}>
                        {adDoc?.title ? adDoc?.title : 'Enter a title...'}
                    </h3>
                    {adDoc?.status === 'active' && (
                        <div style={{background: '#D4EDDA', color: '#155724', fontWeight: 500, width: 'fit-content', fontSize: '12px', height: 'fit-content', borderRadius: '5px', padding: '5px'}}>
                            Running
                        </div>
                    )}
                    {adDoc?.status === 'paused' && (
                        <div style={{background: '#E2E3E5', color: '#383D41', fontWeight: 500, width: 'fit-content', fontSize: '12px', height: 'fit-content', borderRadius: '5px', padding: '5px'}}>
                            Paused
                        </div>
                    )}
                    {adDoc?.status === 'in review' && (
                        <div style={{background: '#FFF3CD', color: '#856404', fontWeight: 500, width: 'fit-content', fontSize: '12px', height: 'fit-content', borderRadius: '5px', padding: '5px'}}>
                            In Review
                        </div>
                    )}
                    {adDoc?.status === 'rejected' && (
                        <div style={{background: '#F8D7DA', color: '#721C24', fontWeight: 500, width: 'fit-content', fontSize: '12px', height: 'fit-content', borderRadius: '5px', padding: '5px'}}>
                            Rejected
                        </div>
                    )}
                    {adDoc?.status === 'stopped' && (
                        <div style={{background: '#D1ECF1', color: '#0C5460', fontWeight: 500, width: 'fit-content', fontSize: '12px', height: 'fit-content', borderRadius: '5px', padding: '5px'}}>
                            Stopped
                        </div>
                    )}
                    {adDoc?.status === 'checkout' && (
                        <div style={{background: '#FFF3CD', color: '#856404', fontWeight: 500, width: 'fit-content', fontSize: '12px', height: 'fit-content', borderRadius: '5px', padding: '5px'}}>
                            Not Paid
                        </div>
                    )}
                    {adDoc?.status === 'scheduled' && (
                        <div style={{background: '#E2E3E5', color: '#383D41', fontWeight: 500, width: 'fit-content', fontSize: '12px', height: 'fit-content', borderRadius: '5px', padding: '5px'}}>
                            Scheduled
                        </div>
                    )}
                    {adDoc?.status === 'completed' && (
                        <div style={{background: '#333', color: '#fff', fontWeight: 500, width: 'fit-content', fontSize: '12px', height: 'fit-content', borderRadius: '5px', padding: '5px'}}>
                            Completed
                        </div>
                    )}
                </div>
                <div className='order__headerDescription'>
                    <div style={{width: '100%', display: 'flex', justifyContent: 'space-between', paddingRight: '8px', boxSizing: 'border-box'}}>
                        <span style={{margin: '5px 0'}}>Views</span>
                        {(postDoc === null || adDoc === null || adDoc?.status === 'checkout' || adDoc?.status === 'scheduled' || adDoc?.status === 'in review') ? (
                            <span>--</span>
                        ) : (
                            <span>{postDoc?.analytics?.views ?? '--'}</span>
                        )}
                    </div>
                    <div style={{width: '100%', display: 'flex', justifyContent: 'space-between', paddingRight: '8px', boxSizing: 'border-box'}}>
                        <span style={{margin: '5px 0'}}>Profile Visits</span>
                        {(postDoc === null || adDoc === null || adDoc?.status === 'checkout' || adDoc?.status === 'scheduled' || adDoc?.status === 'in review') ? (
                            <span>--</span>
                        ) : (
                            <span>{postDoc?.analytics?.profile_visits ?? '--'}</span>
                        )}
                    </div>
                    <div style={{width: '100%', display: 'flex', justifyContent: 'space-between', paddingRight: '8px', boxSizing: 'border-box'}}>
                        <span style={{margin: '5px 0'}}>Spend</span>
                        {adDoc ? (
                            <Fragment>
                                {(adDoc?.status === 'checkout' || adDoc?.status === 'scheduled' || adDoc?.status === 'in review') ? (
                                    <span>-- of {adBudget}</span>
                                ) : (
                                    <span>
                                        {adSpend} of {adBudget}
                                    </span>
                                )}
                            </Fragment>
                        ) : (
                            <span>--</span>
                        )}
                    </div>
                    
                    {(adDoc?.status === "paused" || adDoc?.status === "stopped" || adDoc?.status === "completed") && (
                        <span onClick={() => window.location.href = `/ads/${ad_details._id}`} className='hover_underline' style={{margin: '5px 0', width: 'fit-content', display: 'flex', color: '#000', fontWeight: 500, cursor: 'pointer', zIndex: 10}}>
                            View Results <ArrowRightAltIcon />
                        </span>
                    )}

                    {(adDoc?.status === "active" && timeLeft) && (
                        <div style={{width: '100%', display: 'flex', justifyContent: 'space-between', paddingRight: '8px', boxSizing: 'border-box'}}>
                            <span style={{margin: '5px 0'}}>Time left</span>
                            <span onClick={() => window.location.href = `/ads/${ad_details._id}`}>
                                {formatTimeLeft(timeLeft)}
                            </span>
                        </div>
                    )}
                </div>

                {/* Post Overlay to detect when clicked and redirect to postPage */}
                <div 
                    className="post__overlay" 
                    onClick={() => window.location.href = `/ads/${ad_details._id}`}
                ></div>
            </div>
        </Fragment>
    )
}

Ad_Block.propTypes = {
    pauseAd: PropTypes.func.isRequired,
    stopAd: PropTypes.func.isRequired,
    activateAd: PropTypes.func.isRequired
}

const mapStateToProps = state => ({

    // Mapping the states from the Redux store to the below props

});

export default connect(mapStateToProps, { 

    // Connecting actions to the component
    pauseAd, 
    stopAd,
    activateAd
})(Ad_Block);